import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { Message } from '../../models/message.model';
import { Company } from '../../models/company.model';
import { StorageCenter } from '../../models/storage.center.model';
import { CompanyStorageCenters } from '../../models/company.storage.centers.model';
import { authToken } from '../../scripts/authentication.script';

export class StorageCenterDA {
  static apiResponse: ApiResponse

  public static async getStorageCenters(
    id_company: string,
    storage_center_name: string,
    sort_field: string,
    sort_mode: string,
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companyStorageCenters: CompanyStorageCenters | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/storage.centers.data.json').then(response => { companyStorageCenters = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (companyStorageCenters!.id_company === id_company) {
        companyStorageCenters!.filter = { name: storage_center_name, sort_field: sort_field, sort_mode: sort_mode }

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: companyStorageCenters
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/storage-centers?name=${storage_center_name}&sort_field=${sort_field}&sort_mode=${sort_mode}&page=${page}&limit=${limit}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async getStorageCenter(
    id_company: string,
    id_storage_center: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let storageCenter: StorageCenter | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/storage.center.data.json').then(response => { storageCenter = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (storageCenter!.id === id_storage_center) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: storageCenter
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/storage-centers/${id_storage_center}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async postStorageCenter(
    id_company: string,
    name: string,
    street: string,
    street_number: string,
    additional: string,
    administrative_area: string,
    city: string,
    zip_code: string,
    country: string,
    is_sav: boolean
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let company: Company | null = null
      let storageCenter: StorageCenter | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { company = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (company!.id === id_company) {
        storageCenter = {
          id: `category${(Math.floor(Math.random() * 1000)).toString()}`,
          name: name,
          quantity: 0,
          address: {
            street: street,
            number: street_number,
            additional: additional,
            administrative_area: administrative_area,
            city: city,
            zip_code: zip_code,
            country: country
          }
        }

        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: storageCenter
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/storage-centers`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        name: name,
        is_sav: is_sav,
        address: {
          street: street,
          number: street_number,
          additional: additional,
          administrative_area: administrative_area,
          city: city,
          zip_code: zip_code,
          country: country
        }
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async putStorageCenter(
    id_company: string,
    id_storage_center: string,
    name: string,
    street: string,
    street_number: string,
    additional: string,
    administrative_area: string,
    city: string,
    zip_code: string,
    country: string,
    is_sav: boolean
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let storageCenter: StorageCenter | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/storage.center.data.json').then(response => { storageCenter = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (storageCenter!.id === id_storage_center) {
        storageCenter!.name = name
        storageCenter!.address.street = street
        storageCenter!.address.number = street_number
        storageCenter!.address.additional = additional
        storageCenter!.address.administrative_area = administrative_area
        storageCenter!.address.city = city
        storageCenter!.address.zip_code = zip_code
        storageCenter!.address.country = country

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: storageCenter
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/storage-centers/${id_storage_center}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        name: name,
        is_sav: is_sav,
        address: {
          street: street,
          number: street_number,
          additional: additional,
          administrative_area: administrative_area,
          city: city,
          zip_code: zip_code,
          country: country
        }
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async deleteStorageCenters(
    id_company: string,
    id_storage_centers: string[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let storageCenters: StorageCenter[] | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/storage.centers.data.json').then(response => { storageCenters = response.data.storage_centers }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (storageCenters!.some(item => id_storage_centers.includes(item.id))) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/storage-centers`

      let config: any = {
        headers: { Authorization: authToken() },
        data: { storageCenters: id_storage_centers }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }
}
